import React, { SetStateAction } from 'react';
import GroupedAvailabilityAccordion from './AppointmentLogs/AppointmentLogs';

interface AppointmentAvailabilityLogsProps {
    setShowModal: React.Dispatch<SetStateAction<boolean>>;
    startDate: string | null;
    endDate: string | null;
    locationId: string;
    locationName: string;
}

const AppointmentAvailabilityLogs = ({ setShowModal, startDate, endDate, locationId, locationName }: AppointmentAvailabilityLogsProps) => {

    return <GroupedAvailabilityAccordion setShowModal={setShowModal} locationName={locationName} startDate={startDate} endDate={endDate} locationId={locationId} />;


};

export default AppointmentAvailabilityLogs;
